import Firebase from 'firebase';
//import * as Analytics from 'expo-firebase-analytics';
import 'firebase/firestore'; 
//import getEnvVars from '../environment';

// const { API_KEY, AUTH_DOMAIN, DATABASE_URL, PROJECT_ID, STORAGE_BUCKET, MESSAGING_SENDER_ID, APP_ID, MEASUREMENT_ID } = getEnvVars()

// const firebaseConfig = {
//     apiKey: API_KEY,
//     authDomain: AUTH_DOMAIN,
//     databaseURL: DATABASE_URL,
//     projectId: PROJECT_ID,
//     storageBucket: STORAGE_BUCKET,
//     messagingSenderId: MESSAGING_SENDER_ID, 
//     appId: APP_ID,
//     measurementId: MEASUREMENT_ID
//   };
  
  //let app = Firebase.initializeApp(firebaseConfig);
  //let analytics = Analytics;
  //analytics.setDebugModeEnabled(true);
  //Analytics.setDebugModeEnabled(true)
  //const db = app.firestore();

  //export {db}